<section class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800/40">
  <div class="mb-2.5">
    <h2 class="text-lg font-semibold text-neutral-900 dark:text-white">Logística</h2>
  </div>

  <div class="mb-3.5 grid grid-cols-1 gap-3.5">
    <app-sla-card [sla]="sla" />
    @if (sla.deliveryType === 'Retirada') {
      <app-pickup-address-card [address]="address" />
    } @else {
      <app-delivery-address-card [address]="address" />
    }
  </div>

  @if (expeditionLocation || replenishmentLocation) {
    <div class="grid grid-cols-1 gap-3.5">
      @if (expeditionLocation) {
        <app-fulfillment-location-card [location]="expeditionLocation" />
      }
      @if (replenishmentLocation) {
        <app-fulfillment-location-card [location]="replenishmentLocation" />
      }
    </div>
  }
</section>
